import React from "react";
import ServiceItem from "../Domain/ServiceItem.js";
import AuthService from "./authService.js";
import SearchParams from "../Elements/SearchParams";
import SLSearchParams from "../Contents/Planning/Service/SLSearchParams";

class PlanningServiceItemService extends React.Component {
  static GetServiceItems(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, SLSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/VPlanningServiceItem/GetVPlanningServiceItems/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBServiceItems(ServiceItems) {
    const convertedServiceItems = [];

    if (ServiceItems !== null) {
      ServiceItems.forEach(item => {
        const newItem = new ServiceItem(item);
        convertedServiceItems.push(newItem);
      });
    }

    return convertedServiceItems;
  }
}

export default PlanningServiceItemService;
